/**
 * Shared helpers to respect user notification preferences (visual + audio).
 */

export const isNotificationTypeDisabled = (prefs, type) => {
    if (!type) return false;
    return (prefs?.disabledTypes || []).includes(type);
};

/** Toast popups — only for style === 'toast' */
export const shouldShowVisualToast = (prefs, data) => {
    if (!prefs) return false;
    if (prefs.style !== 'toast') return false;
    if (isNotificationTypeDisabled(prefs, data?.type)) return false;
    return true;
};

/** Bell badge / realtime counter — allowed for toast and badge-only */
export const shouldUpdateNotificationBadge = (prefs, data) => {
    if (!prefs) return false;
    if (prefs.style === 'silent') return false;
    if (isNotificationTypeDisabled(prefs, data?.type)) return false;
    return true;
};

/** Audio — blocked when silent or all mapped types are disabled */
export const shouldPlayAudioForKey = (prefs, globalConfig, audioKey) => {
    if (!prefs) return false;
    if (prefs.style === 'silent') return false;
    if (globalConfig?.audioNotifications?.enabled === false) return false;

    const audioKeyToTypes = {};
    if (globalConfig?.notificationTypes) {
        Object.entries(globalConfig.notificationTypes).forEach(([type, cfg]) => {
            if (cfg.audioKey) {
                if (!audioKeyToTypes[cfg.audioKey]) audioKeyToTypes[cfg.audioKey] = [];
                audioKeyToTypes[cfg.audioKey].push(type);
            }
        });
    }

    const disabledAudioTypes = prefs?.disabledAudioTypes || [];
    const typesForKey = audioKeyToTypes[audioKey] || [];
    if (typesForKey.length === 0) return true;

    return !typesForKey.every((t) => disabledAudioTypes.includes(t));
};

export const AUTH_PUBLIC_ROUTES = ['/login', '/logout', '/monitor', '/compras/aprobar'];

export const isPublicAuthRoute = (pathname) =>
    AUTH_PUBLIC_ROUTES.some((route) => pathname.startsWith(route));
